import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { EPaths } from 'router/const/paths';

import { searchParamsNames } from 'constants/searchParamsNames';

import type { EUnavailableType } from '../constants/unavailableType';

/** Хук для работы со страницей "Недоступный контент" */
export function useUnavailableContent() {
    const [searchParams] = useSearchParams();

    return useMemo(
        () => ({
            /** Переход на страницу "Недоступный контент" */
            redirectToUnavailableContentPage: (type: EUnavailableType) => {
                searchParams.set(searchParamsNames.unavailableContentType, type);
                window.location.assign(`/${EPaths.UNAVAILABLE_CONTENT}?${searchParams}`);
            },
            /** Получить тип недоступного контента */
            unavailableContentType: searchParams.get(searchParamsNames.unavailableContentType) as EUnavailableType | null,
        }),
        [searchParams],
    );
}
